import React from "react";

const ServicePill = ({ service }) => {
  return <span className="service-pill">{service}</span>;
};

export default ServicePill;
